"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withUAL = void 0;

var _react = _interopRequireDefault(require("react"));

var _UALContext = require("./UALContext");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/**
 * @type {function}
 * @name withUAL
 * @desc Function for making a component a consumer of the UAL context
 */


var withUAL = function withUAL(WrappedComponent) {
  return function (props) {
    var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var WithUAL = function WithUAL(wrappedProps) {
      return /*#__PURE__*/_react["default"].createElement(_UALContext.UALContext.Consumer, null, function (context) {
        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({}, wrappedProps, {
          ual: context
        }));
      });
    };

    WithUAL.displayName = "withUAL(".concat(displayName, ")");
    return /*#__PURE__*/_react["default"].createElement(WithUAL, props);
  };
};

exports.withUAL = withUAL;